import CertificateTemplateAdd from './CertificateTemplateAdd'

export default CertificateTemplateAdd
